<template>
  <nav id="nav"
       :class="{'open-mobile' : toggledMobileMenu}"
       class="up"
       role="navigation">
    <ul class="dropdown menu"
        data-dropdown-menu
        role="menubar">
      <router-link id="navLogoContainer"
                   to="/">
        <img src="../../assets/svmic-logo.png"
             alt="SVMIC Logo"/>
      </router-link>
      <NavigationItem v-for="item in $options.items"
                      :key="item.path"
                      :text="item.text"
                      :path="item.path"
                      :has-sub-items="item.subItems !== undefined">
        <template v-if="item.subItems">
          <NavigationItemSubmenu>
            <NavigationItem v-for="subItem in item.subItems"
                            :key="subItem.path"
                            :text="subItem.text"
                            :path="subItem.path"
                            :is-sub-menu-item="true"/>
          </NavigationItemSubmenu>
        </template>
      </NavigationItem>
      <div class="nav-right">
        <div class="site-title">2022 Annual Report</div>
        <a :href="`${baseUrl}SVMIC 2022 Annual Report.pdf`"
           target="_blank"
           download="SVMIC 2022 Annual Report"
           class="download-link"
        >
          Download Printable PDF
        </a>
      </div>
      <NavigationHamburger @toggle-mobile-menu="toggleMobileMenu"
                           :toggled-mobile-menu="toggledMobileMenu"
                           :class="toggledMobileMenu ? 'open' : 'closed'"/>
    </ul>
    <TheNavigationMobile :class="{ 'show-mobile-menu': toggledMobileMenu }"/>
  </nav>
</template>
<script>
import NavigationItem from '@/components/navigation/NavigationItem';
import NavigationItemSubmenu from '@/components/navigation/NavigationItemSubmenu';
import router from '@/router/index';
import NavigationHamburger from '@/components/navigation/NavigationHamburger';
import TheNavigationMobile from '@/components/navigation/mobile/TheNavigationMobile';

export default {
  name: 'TheNavigation',
  components: {
    TheNavigationMobile,
    NavigationHamburger,
    NavigationItemSubmenu,
    NavigationItem
  },
  props: {
    toggledMobileMenu: Boolean
  },
  mixins: [
    // eslint-disable-next-line
    require('../../mixins/foundation'),
  ],
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  created () {
    const allRoutes = router.options.routes;
    this.$options.items = [];
    for (const route of allRoutes) {
      const item = {
        text: route.name,
        path: route.path
      };
      if ('subRoutes' in route) {
        item.subItems = [];
        for (const subRoute of route.subRoutes) {
          item.subItems.push({
            text: subRoute.name,
            path: subRoute.path
          });
        }
      }
      this.$options.items.push(item);
    }
  },
  methods: {
    toggleMobileMenu: function () {
      this.$emit('toggle-mobile-menu');
    }
  }
};
</script>
